// extracted by mini-css-extract-plugin
export default {"mainBodyContainer":"BodyComponent_mainBodyContainer__qeiT+","entireDisplayText":"BodyComponent_entireDisplayText__dkJj8"};